const doc = [[({"flow":"inicio", "rules":[({"message":"Olá {primeiroNome}!"}), ({"message":"Vi que você não tem nenhum monitoramento. Você já conhece a ferramenta de monitoramentos do Escavador?"}), ({"message":"Com ela você pode acompanhar seu nome, o nome de sua empresa, processos judiciais e até termos de seu interesse."}), ({"message":"E, sempre que encontrarmos algo, notificaremos você via e-mail."}), ({"message":"Você deseja testar gratuitamente?", "type":"SingleChoice", "options":[({"label":"Sim, quero utilizar"})]}), ({"message":"Que maravilha!"}), ({"message":"{primeiroNome}, preciso que você confirme seu e-mail antes de continuarmos", "skip":(function anonymous(output,rule,bot
) {

  return output.emailConfirmado;

})}), ({"message":"Basta abrir sua caixa de entrada do e-mail {email} e clicar no link que enviamos", "skip":(function anonymous(output,rule,bot
) {

  return output.emailConfirmado;

}), "actions":[({"reenviarConfirmacaoCadastro":true})]}), ({"message":"Estou enviando novamente esse e-mail para você", "skip":(function anonymous(output,rule,bot
) {

  return output.emailConfirmado;

}), "type":"SingleChoice", "options":[({"label":"Já confirmei"})], "validators":[({"verificar-email-confirmado":true})]}), ({"message":"Como eu disse, você pode monitorar um termo ou um processo judicial"}), ({"message":"Um termo pode ser seu nome completo, nome de uma empresa, OAB de um advogado, etc.."}), ({"message":"Você deseja monitorar um termo ou um processo judicial?", "type":"SingleChoice", "name":"monitoramento.tipo", "options":[({"label":"Termo", "value":"termo"}), ({"label":"Processo", "value":"processo"})], "replymessage":"Certo!", "replydelay":1})]}), ({"flow":"monitorar_termo", "rules":[({"message":"Qual termo você quer monitorar?", "skip":(function anonymous(output,rule,bot
) {

  return output.monitoramento.tipo == 'processo';

}), "type":"String", "name":"monitoramento.termo", "validators":[({"min":3, "warning":"Informe uma palavra com mais que 3 letras"}), ({"termoValido":true})]}), ({"message":"Ok! Você quer monitorar seu nome", "skip":(function anonymous(output,rule,bot
) {

  if (output.monitoramento.termo == 'meu nome') {
    output.monitoramento.termo = output.nome;
    output.criouMonitoramentoNome = true;
    return false;
  } else {
    output.criouMonitoramentoNome = false;
    return true;
  }

})}), ({"message":"{monitoramento.termo} é uma:", "skip":(function anonymous(output,rule,bot
) {

  return output.monitoramento.tipo == 'processo';

}), "type":"SingleChoice", "name":"monitoramento.categoria", "options":[({"label":"Pessoa", "value":"PESSOA"}), ({"label":"Empresa", "value":"EMPRESA"}), ({"label":"Outro", "value":"OUTRA"})]}), ({"message":"Quer monitorar nos Diários Oficiais do seu estado ({estadoUf}), ou em todo o país?", "skip":(function anonymous(output,rule,bot
) {

  return output.monitoramento.tipo == 'processo' || output.estadoId == null;

}), "type":"SingleChoice", "name":"locais", "options":[({"label":"Só no meu estado", "value":"estado"}), ({"label":"No país todo", "value":"pais"})]})]}), ({"flow":"monitorar_processo", "rules":[({"message":"Me informe o número do processo", "type":"String", "name":"monitoramento.termo", "validators":[({"numeroUnico":true})], "skip":(function anonymous(output,rule,bot
) {

  return output.monitoramento.tipo == 'termo';

})})]}), ({"flow":"salvar_monitoramento", "rules":[({"message":"Ok! Aguarde um momento...", "actions":[({"cadastrarMonitoramento":true})]}), ({"message":"Pronto!"}), ({"message":"Seu monitoramento foi criado!"}), ({"message":"Assim que encontrarmos algo, te avisaremos por e-mail."}), ({"message":"Enquanto isso, você será direcionado para o seu painel de Monitoramentos."}), ({"message":"Abraços!"}), ({"actions":[({"redirecionarPainel":true})]})]})]];
module.exports = doc.length <= 1 ? doc[0] : doc;